module.exports = __webpack_public_path__ + "img/deny-call.6f03e17b.svg";